import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sami-select 383",
  "use": "icon-sami-select 383-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-sami-select 383\"><path d=\"M810.666667 480v64H213.333333v-64z\" p-id=\"25007\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol